<template>
  <div>
    <div style="padding: 20px 0 0 0">
      <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="search"
        class="demo-form-inline">
        <input type="text" style="display:none">
        <el-form-item label="调拨单编号：" v-if="listType == 0">
          <el-input maxlength='450' v-model="formInline.transferWarehouseCode" placeholder="请填入调拨单编号"></el-input>
        </el-form-item>
        <el-form-item label="发货单编号：" v-if="listType == 1">
          <el-input maxlength='450' v-model="formInline.transferDeliveryTaskCode" placeholder="请填入发货单编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="restSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="dataSource" style="width: 100%" :border="true" size="medium">
      <el-table-column type="expand" style="padding-lef: 50px" class="test">
        <template slot-scope="props">
          <el-table :data="props.row.productRespDTOList">
            <el-table-column type="expand">
              <template slot-scope="props_son">
                <el-table :data="props_son.row.pkgList">
                  <el-table-column label="批次包编号" prop="pkgCode">
                  </el-table-column>
                  <el-table-column label="本次调拨出库数量" prop="amount">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="商品信息" prop="productName">
              <template slot-scope="product">
                <div class="productClass">
                  <ImgView :src="product.row.productImg" width="80" height="80" />
                  {{ product.row.productName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品SKU" prop="productSku"> </el-table-column>
            <el-table-column label="商品规格" prop="productProp"> </el-table-column>
            <el-table-column label="已出库数量" prop="productTransferNum">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="调拨单编号" prop="transferWarehouseCode" v-if="listType == 0">
      </el-table-column>
      <el-table-column label="发货单编号" prop="transferDeliveryTaskCode" v-if="listType == 1">
      </el-table-column>
      <el-table-column label="店铺名称" prop="customerShopName" v-if="listType == 0">
      </el-table-column>
      <el-table-column label="出库仓" prop="outboundWarehouse">
        <template slot-scope="props">
          <div>{{showout(props.row.outboundWarehouseCode)}}</div>
        </template>
      </el-table-column>
      <el-table-column label="收件仓" prop="inboundWarehouse">
        <template slot-scope="props">
          <div>{{showin(props.row.inboundWarehouseCode)}}</div>
        </template>
      </el-table-column>
      <el-table-column label="发货时间" prop="createTime" v-if="listType == 1">
      </el-table-column>
      <el-table-column label="已发批次包" prop="logisticsNo" v-if="listType == 0">
        <template slot-scope="props">
          <div @click="detail(props.row)" style="color:#008dde">
            <span>详情</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="物流单号" prop="logisticsNo" v-if="listType == 1">
      </el-table-column>
      <el-table-column label="操作" prop="logisticsCode" v-if="listType == 0">
        <template slot-scope="props">
          <div @click="print(props.row)" style="color:#008dde">
            <span>打印拣货</span>
          </div>
          <div @click="toAddPkg(props.row)" style="color:#008dde">
            <span>添加发货单</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="query.current" :page-size="10" :page-sizes="[10, 20, 40]"
      layout="total, sizes, prev, pager, next" :total="total" background style="float:right;margin-top: 20px;">
    </el-pagination>

    <div class="startprint" ref="startprint">
      <el-table :data="printData" size="medium">
        <el-table-column label="批次包编码" prop="pkgCode">
        </el-table-column>
        <el-table-column label="数量" prop="amount"></el-table-column>
        <el-table-column label="货格码" prop="gridCode"></el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="dialogShow">
      <el-table :data="detailList" size="medium">
        <el-table-column label="发货编号" prop="transferDeliveryTaskCode"></el-table-column>
        <el-table-column label="收件仓" prop="transferWarehouseCode"></el-table-column>
        <el-table-column label="批次包编码" prop="pkgCode"></el-table-column>
        <el-table-column label="本次调拨出库数量" prop="amount"></el-table-column>
        <el-table-column label="货格码" prop="gridCode"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import {
  columns,
  dataSourceMap,
} from "@/views/outOfDomestic/domesticShipment/returnGoods/components/ComTableData";
import { transferList, transferPrint } from "@/apis/outDomestic";

export default {
  name: "ComTable",
  components: {
    WmsTable,
    ImgView,
  },
  props: {
    listType: {
      type: String, // tab 页类型
      required: true,
    },
    dataSource: {
      type: Array, 
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    warehouseData: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        transferWarehouseCode: undefined,
        transferDeliveryTaskCode: undefined,
        // deadline: null,
      },
      columns,
      dialogShow: false,
      // dataSource: [],
      selectedRows: [],
      printData: [],
      detailList: []
    };
  },
  methods: {
    search(){
      this.query.current = 1
      this.onSubmit();
    },
    onSubmit: function () {
      let emitData = {
        formInline: this.formInline,
        listType: this.listType,
      };
      emitData.formInline.pageNum = this.query.current
      emitData.formInline.pageSize = this.query.pageSize
      this.$emit("search", emitData);
    },
    restSubmit: function () {
      this.formInline = {
        transferWarehouseCode: undefined,
        transferDeliveryTaskCode: undefined,
      };
      this.onSubmit();
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.query.current = val
      this.onSubmit();
    },
    pageChangeCall: function (payload) {
      console.log("payload", payload);
      const { current, pageSize } = payload;
      this.query = {
        current,
        pageSize,
      };
      this.getList();
    },
    selectChangeCall: function (rows) {
      console.log("rows", rows);
      this.selectedRows = rows;
    },
    exportShipInvoice: function () {
      console.log(this.selectedRows);
    },
    setExpressNo: function (record) {
      // TODO add or update ExpressNo
      console.log(record);
      this.getList();
    },
    toAddPkg(row) {
      console.log(row);
      this.$router.push({
        name: "addPkg",
        params: { transferWarehouseCode: row.transferWarehouseCode, customerShopId: row.customerShopId },
      });
    },
    print(row) {
      console.log(row);
      let params = {
        transferWarehouseCode: row.transferWarehouseCode,
      };
      transferPrint(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          let arr = []
          // row.transferWarehousePkgRespDTOS.forEach(item => {
          //   item.pkgList.forEach(item_son => {
          //     arr.push(item_son)
          //   })
          // })
          this.printData = row.transferWarehousePkgRespDTOS
          this.$nextTick((_) => {
            let printDiv = this.$refs.startprint
            console.log(this.$refs)
            console.log(printDiv)
            let app = document.getElementById('app')
            app.style.opacity = 0
            printDiv.style['z-index'] = 9
            document.body.appendChild(printDiv);
            window.print();
            app.style.opacity = 1
            printDiv.style['z-index'] = -9
          });
        }
      });
    },
    detail(row) {
      console.log(row)
      this.detailList = row.transferWarehousePkgRespDTOS
      this.dialogShow = true
    },
    showin(code){
      let cache = ''
      this.warehouseData.forEach(item => {
        if(item.wareCode == code){
          cache = item.wareName
        }
      })
      return cache
    },
    showout(code){
      let cache = ''
      this.warehouseData.forEach(item => {
        if(item.wareCode == code){
          cache = item.wareName
        }
      })
      return cache
    }
  },
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.action__div--flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.span__btn {
  cursor: pointer;
  padding: 6px 0;
}

.productClass {
  display: flex;
  align-items: center;
}


.startprint {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -9;
  width: 800px;
}
</style>
